import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IGalleryPhoto } from '../constants/sensorGalleryType';

interface IResponse {
  data: IGalleryPhoto[];
}

export const equipmentImagesListKey = (equipment_id?: string) => ['equipmentImagesList', equipment_id];

const equipmentImagesListFn = ({ queryKey }: QueryFunctionContext<string[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/equipment/${queryKey[1]}/photos`);

const equipmentImagesListSelect = ({ data }: AxiosResponse<IResponse>) => data.data;

export const useEquipmentImagesListQuery = ({ equipment_id }: { equipment_id?: string }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: equipmentImagesListKey(equipment_id),
    queryFn: equipmentImagesListFn,
    select: equipmentImagesListSelect,
  });
};
